import React, { useState, useEffect } from "react";
import {
    Button, Modal, Input, Tag, Checkbox, Alert
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setExactTerm, setFreeForm } from "../../store/components/Reports.slice";
import { setReportBuilderMode } from "../../store/components/ReportBuilder.slice";
import { loadFreeFormReports } from "../../utils/report/ReportsHelper";

function FreeFormModal({
    visible,
    onClose = () => { }
}) {
    const dispatch = useDispatch();
    const [modelInput, setModelInput] = useState("");
    const [inputText, setInputText] = useState([]);
    const [isExactTerm, setIsExactTerm] = useState(false);
    const [popWarn, setPopWarn] = useState(false);
    const { freeForm, exactTerm, freeFormTypeToAdd } = useSelector((state) => state.reports);

    const handleInputEnter = (value) => {
        if (value) {
            setInputText((prev) => {
                return value.split("\n").reduce((acc, text) => {
                    const tempText = text.trim();
                    if (tempText && !acc.includes(tempText)) {
                        if (acc.length >= 10) {
                            setPopWarn(true);
                        } else acc.push(tempText);
                    }
                    return acc
                }, [...prev])
            });
        }
        setModelInput("");
    };

    const removeText = (value) => {
        setInputText(inputText.filter((text) => text !== value));
    };

    const handleClose = () => {
        setPopWarn(false);
    };

    useEffect(() => {
        if (visible) {
            setInputText([...freeForm]);
            setIsExactTerm(exactTerm);
        }
    }, [visible, freeForm, exactTerm]);


    return (
        <Modal
            className="report--freeformmodal"
            open={visible}
            closable={false}
            maskClosable={false}
            title={(
                <div className="d-flex" style={{ width: "100%" }}>
                    <div className="header d-flex-col flex-1">
                        <b className="report--freeformmodal--title">Add Report</b>
                        <p className="report--freeformmodal--subtitle">Input keyword you would like to associate to your target audience.</p>
                    </div>
                    <Button
                        style={{ padding: 0, marginLeft: "5mm" }}
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => {
                            onClose(false);
                        }}
                    />
                </div>
            )}
            okText="Generate"
            onCancel={() => {
                onClose(false);
            }}
            onOk={() => {
                dispatch(setFreeForm(inputText));
                dispatch(setExactTerm(isExactTerm));

                if (freeFormTypeToAdd === "new") {
                    dispatch(setReportBuilderMode("freeform"));
                } else {
                    loadFreeFormReports(false);
                }
                onClose(false);
            }}
        >
            <div className={`${popWarn ? "warning" : ""} report--freeformmodal--container d-flex-col`}>
                {
                    inputText.length !== 0 && (
                        <div className="report--freeformmodal--tagcontainer" key="tagSectionKey">
                            {inputText.map((item) => (
                                <Tag className="oi-tag" closable onClose={() => removeText(item)} key={item}>{item}</Tag>
                            ))}
                        </div>
                    )
                }
                {
                    popWarn ? null :
                        <Input.TextArea
                            className="flex-1"
                            style={{
                                height: "100%"
                            }}
                            bordered={false}
                            value={modelInput}
                            onChange={(e) => setModelInput(e.target.value)}
                            onPressEnter={(e) => {
                                handleInputEnter(modelInput.trim());
                            }}
                            onBlur={(e) => {
                                handleInputEnter(modelInput.trim());
                            }}
                        />
                }
            </div>
            <div className="report--freeformmodal--footer">
                <div className="layer">
                    {popWarn &&
                        (<Alert message="To add more keywords, please contact your account manager." type="warning" showIcon closable afterClose={handleClose} />)
                    }
                </div>
                <div className="layer">
                    <Checkbox
                        checked={isExactTerm}
                        onChange={(e) => {
                            setIsExactTerm(e.target.checked);
                        }}
                    >
                        Exact Term
                    </Checkbox>
                    <p className="count">{inputText.length}/10</p>
                </div>

            </div>
        </Modal>
    );
}

export default FreeFormModal;
